import { useMemo, useState } from 'react';

type TextError = {
  duplicate: boolean;
  length: boolean;
};

export const initTextError = {
  duplicate: false,
  length: false,
};

export const useTextError = () => {
  const [state, setState] = useState<TextError>(initTextError);
  const isError = useMemo(() => state.duplicate || state.length, [JSON.stringify(state)]);

  const helperText = useMemo(() => {
    if (state.duplicate) return 'Duplicate name';
    if (state.length) return 'Name is too long';
    return '';
  }, [JSON.stringify(state)]);

  return {
    isError,
    error: state,
    setError: setState,
    helperText,
  };
};
